import { IForm } from 'core-components/classes/models/IForm'
import { createWidget } from 'core-components/sitebuilder/layout/flexItem/helpers/createWidget'
import { IWidget } from 'core-components/sitebuilder/models/IWidget'
import { parseData } from 'src/core/classes/helpers'

export interface IContentRemoteSettings {
  includedLibraries: { src: string; type: string }[]
}
export type TAppIframeWidgetData = (widgetName: string) => IForm | Promise<IForm> | null

export const mapWidgets = (rows: object[]): IWidget[] => {
  return rows
    .map((row) => {
      const descr = row['Description'] || ''
      const showP = descr.split('show=')[1]
      const hideP = descr.split('hide=')[1]
      const addP: any[] = []
      if (showP) {
        addP.push({ paramName: showP })
      }
      if (hideP) {
        addP.push({ paramName: hideP })
      }

      const data: IWidget = {
        i: row['Id'],
        x: row['X'] || 0,
        y: row['Y'] || 0,
        w: row['Width'] || 1,
        h: row['Height'] || 10,
        scale: row['Scale'] || 100,
        title: row['Title'] || '',
        description: row['Description'] || '',
        content: row['Content'] || '',
        type: row['Type'] || '',
        group: row['GroupName'] || '',
        src: row['ExternalUrl'],
        viewModel: row['ViewModel'],
        createdAt: row['CreatedAt'],
        createdBy: row['CreatedBy'],
        hideHeader: !!row['HideHeader'],
        isDraggable: !!row['AllowMove'],
        isResizable: !!row['AllowResize'],
        isScalable: !!row['AllowScale'],
        autoHeight: !!row['AutoResizeHeight'],
        allowWindowMode: !!row['AllowWindowMode'],
        disableMargin: !!row['DisableMargin'],
        roleIds: row['Roles'],
        styleSettings: parseData(row['StyleSettings'], 'object'),
        roles: row['Roles'],
        routes: (row['Routes'] || row['Description'] || '')
          .split(',')
          .map((r: string) => {
            return {
              paramName: r,
              query: false,
            }
          })
          .concat(addP),
        isNew: false,
        settings: parseData(row['Settings'], 'object'),
      }
      const isValid = !!data.i
      return isValid ? createWidget(data) : null
    })
    .filter((i) => i !== null) as IWidget[]
}

export const mapWidgetToDB = (widget: IWidget, appId: string) => {
  return {
    AllowEvents: false,
    AllowMove: widget.isDraggable || false,
    AllowResize: widget.isResizable || false,
    AllowScale: widget.isScalable || false,
    AllowWindowMode: widget.allowWindowMode || false,
    HideHeader: widget.hideHeader || false,
    AppId: appId || undefined,
    AutoResizeHeight: widget.autoHeight || false,
    Content: widget.content,
    ExternalUrl: widget.src,
    GroupName: widget.group,
    Height: widget.h,
    StyleSettings: JSON.stringify(widget.styleSettings || {}),
    Id: widget.i || undefined,
    Title: widget.title,
    Description: widget.description,
    Type: widget.type || undefined,
    Width: widget.w,
    X: widget.x,
    Y: widget.y,
    Scale: widget.scale,
    Settings: JSON.stringify(widget.settings || {}),
  }
}
